export default {
  brand: 'CrypPay',
  transferHint: 'กรุณาโอนเงินไปยังที่อยู่ด้านล่าง',
  rechargeAmount: 'จำนวนเงินเติม',
  rechargeAddress: 'ที่อยู่สำหรับเติมเงิน',
  scanTip: 'สแกน QR ด้วยวอลเล็ตของคุณเพื่อโอนเงิน',
  copy: 'คัดลอก',
  copied: 'คัดลอกแล้ว',
  copyFail: 'คัดลอกไม่สำเร็จ',
  networkFee: 'ค่าธรรมเนียมเครือข่าย',
  eta: 'เวลาที่คาดว่าจะได้รับ',
  etaVal: '5-15 นาที',
  actualArrival: 'จำนวนที่ได้รับจริง',
  noticeTitle: 'ข้อควรระวัง',
  notice1: 'กรุณาโอนเฉพาะไปยัง QR โค้ดหรือที่อยู่ที่แสดงในหน้านี้เท่านั้น หากโอนผิดที่อยู่จะไม่สามารถกู้คืนได้',
  notice2: 'จำนวนเงินที่โอนต้องตรงกับ {amount} {coin} เท่านั้น หากไม่ตรงระบบจะไม่สามารถเติมเงินอัตโนมัติได้',
  notice3: 'กรุณารอการยืนยันจากเครือข่ายบล็อกเชน (โดยปกติ 1 การยืนยันจะได้รับเงินอัตโนมัติ)',
  notice4: 'การโอนบนบล็อกเชนไม่สามารถยกเลิกได้ ความเสียหายจากความผิดพลาดของผู้ใช้ผู้ใช้ต้องรับผิดชอบเอง',
  selectLang: 'เลือกภาษา',
  back: 'กลับ',
  pending: 'รอชำระเงิน',
  paid: 'ชำระแล้ว',
  timeout: 'หมดเวลา',
  orderNo: 'เลขที่คำสั่งซื้อ',
  loading: 'กำลังโหลด…',
  paramError: 'พารามิเตอร์ลิงก์ไม่สมบูรณ์',
  initFail: 'สร้างคำสั่งซื้อไม่สำเร็จ',
  paidSuccess: 'ชำระเงินสำเร็จ',
  timedOut: 'คำสั่งซื้อหมดอายุ กรุณาสร้างใหม่'
}